import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Popup } from 'semantic-ui-react';


const Bead = (props) => {
    const { beadstate, small, tooltipText, color, style } = props;

    let beadClassName = classnames({
        "c-bead": true,
        [color]: (color ? true : false)
    });

    let circleClassName = classnames({
        "c-bead__circle": true,
        "small": small ? true : false
    });

    let iconStyle = {
        'font-size': 'inherit',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: '#FFF'
    };

    let iconClassName = classnames({
        "fa": true,
        "fa-exclamation": (beadstate === "half"),
        "fa-times": (beadstate === "empty"),
        "fa-check": (beadstate === "full")
    });

    const circle = (<div className={circleClassName}>
        <i className={iconClassName} style={iconStyle} />
    </div>);

    return (<div className={beadClassName} style={style}>
        <Popup trigger={circle} content={tooltipText} />
    </div>);
};

Bead.propTypes = {
    beadstate: PropTypes.string,
    small: PropTypes.bool,
    tooltipText: PropTypes.string,
    color: PropTypes.string,
    style: PropTypes.object
};

export default Bead;